import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HighchartsChartModule } from 'highcharts-angular';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { SiteHeadersComponent } from './_layouts/site-headers/site-headers.component';
import { SiteFooterComponent } from './_layouts/site-footer/site-footer.component';
import { SpinnerComponent } from './_layouts/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { DecryptionInterceptor } from './_helpers/decryption.interceptor';
import { DecryptionService } from './services/decryption.service';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { dataReducer } from './store/reducer';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { environment } from 'src/environments/environments';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { OnesignalNgxModule } from 'onesignal-ngx';
import { ServiceWorkerModule } from '@angular/service-worker';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    const nextState = reducer(state, action);
    localStorage.setItem('appState', JSON.stringify(nextState));
    return nextState;
  };
}

export function getInitialState() {
  const savedState = localStorage.getItem('appState');
  return savedState ? JSON.parse(savedState) : undefined;
}

const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HighchartsChartModule,
    ReactiveFormsModule,
    SiteHeadersComponent,
    SiteFooterComponent,
    HttpClientModule,
    NgxDaterangepickerMd.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    // OnesignalNgxModule,
    AngularFireMessagingModule,
    SpinnerComponent,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,  
    }),
    NgxSpinnerModule,
    StoreModule.forRoot({ appState: dataReducer }, { metaReducers, initialState: getInitialState() }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: false }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: DecryptionInterceptor, multi: true },
    //DecryptionService,
    DatePipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
